export const GameState = {
  level: 1,
  score: 0,
  targetScore: 0,
  grid: [],
  selectedTile:{} ,
  timeLeft: 0,
  isProcessing: false
}
